const toValidDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const pad = (value) => String(value).padStart(2, "0");

export const formatDate = (value, fallback = "-") => {
  const date = toValidDate(value);
  if (!date) return fallback;
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
};

export const formatDateTime = (value, fallback = "-") => {
  const date = toValidDate(value);
  if (!date) return fallback;
  return `${formatDate(date, fallback)}, ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};
